import { Navigate } from "react-router";
import { authClient } from "../../../api";
import { Loading } from "../../../shared/components";
import { buildDefaultWorkspacePath } from "../../../shared/layout";

export function HomePage() {
  const organizations = authClient.useListOrganizations();
  if (organizations.isPending) {
    return <Loading />;
  }
  return (
    <Navigate
      to={
        organizations.data?.[0]
          ? buildDefaultWorkspacePath(organizations.data[0].id)
          : "/workspaces/new"
      }
      replace
    />
  );
}
